import { render, staticRenderFns } from "./DiscoveryStatsHintsItem.vue?vue&type=template&id=d1208882"
import script from "./DiscoveryStatsHintsItem.vue?vue&type=script&lang=js"
export * from "./DiscoveryStatsHintsItem.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryStatsHintsItem.vue?vue&type=style&index=0&id=d1208882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports